import React, { useEffect, useState } from 'react'
import DashboardHeader from '../DashboardHeader/DashboardHeader'
import { Menu, MenuHandler, MenuItem, MenuList, Tooltip } from '@material-tailwind/react'
import { BsThreeDots } from 'react-icons/bs'
import DeleteProductModal from '../DeleteProductModal/DeleteProductModal'
import ArchiveProductModal from '../ArchiveProductModal/ArchiveProductModal'
import { CalcIcon, CopyIcon2, PencilIcon } from '../../Assets/AllSvg'
import { AiTwotoneDelete } from 'react-icons/ai'
import { BiPlus } from 'react-icons/bi'
import { GetPriceByID } from '../API/PriceAPI'
import { useLocation } from 'react-router'
import AddPriceModal from '../AddPriceModal/AddPriceModal'

const ProductPriceDetail = () => {
    const [editPrice, setEditPrice] = useState('')
    const [addPrice, setAddPrice] = useState(false)
    const [active, setActive] = useState(false)
    const [delProduct, setDelProduct] = useState(false)
    const [sendData, setSendData] = useState('')
    const [options, setOptions] = useState({
        metaData: false
    })
    const [priceData, setPriceData] = useState('')
    const [deleteProduct, setDeleteProduct] = useState('')
    const [prodDel, setProdDel] = useState(false)
    const [productName, setProductName] = useState('')

    const location = useLocation()
    const ID = location.pathname.split('/').pop()

    const handleAddMetadata = () => {
        setOptions({ ...options, metaData: !options.metaData })
    }

    const handleOpenEditPrice = () => {
        setAddPrice(true)
        setEditPrice(priceData)
    }

    const handleOpenArchivePrice = () => {
        setActive(!active)
        setSendData('price')
    }

    const handleOpenDelPrice = () => {
        setDelProduct(true)
        setSendData('price')
        setDeleteProduct(priceData)
    }

    const getPriceData = async () => {
        const result = await GetPriceByID(ID)
        setPriceData(result)
        setProductName(location.state.data)
    }

    useEffect(() => {
      getPriceData()
    }, [])
    
    return (
        <>
            <div>
                <DashboardHeader />
                <div className="max-w-[1690px] mx-auto sm:p-[40px] p-[20px] w-full text-[#414552]">
                    <div className="flex items-center justify-between">
                        <div className='flex items-center gap-2 text-[#687385] text-[13px] cursor-pointer'>
                            <button><CalcIcon className='fill-[#687385]' /></button>
                            <span className='font-medium'>PRICE</span>
                        </div>
                        <Tooltip className="bg-gray-800 text-white" content={
                            <div className='flex items-center text-sm gap-1 rounded-sm'>Copy ID <div className="ml-1 flex gap-1 items-center p-[1px_6px] rounded-sm bg-gray-700 text-xs font-normal">ctrl</div>+<div className="ml-1 flex gap-1 items-center p-[1px_6px] rounded-sm bg-gray-700 text-xs font-normal">i</div></div>
                        }>
                            <button className='text-xs text-[#687385] flex items-center gap-1'>{priceData.price_id}<CopyIcon2 className="fill-[#687385]" /></button>
                        </Tooltip>
                    </div>
                    <div className="flex items-center justify-between pb-3 border-b-[1px] border-[#ebeef1] sm:mt-0 mt-3">
                        <div className="flex gap-4 items-center">
                            <h3 className='text-[#1a1b25] font-bold sm:text-[28px] text-[20px]'>Price for {productName}</h3>
                        </div>
                        <div className="flex items-center gap-2">
                            <button onClick={handleOpenEditPrice} className="input_focus_shadow h-[28px] text-[#414552] flex gap-2 items-center rounded-[6px] text-[14px] font-semibold p-[0_8px]"><PencilIcon />Edit</button>
                            <Menu placement="bottom-center">
                                <MenuHandler>
                                    <button className='input_focus_shadow px-2 py-1 hover:bg-white rounded-md'><BsThreeDots /></button>
                                </MenuHandler>
                                <MenuList className='px-0 py-2 mt-2 min-w-[168px] outline-remove'>
                                    <MenuItem onClick={handleOpenArchivePrice} className='text-sm font-medium text-[#625afa] px-[12px] py-1 rounded-none'>Archive price</MenuItem>
                                    <MenuItem onClick={handleOpenDelPrice} className='text-sm font-medium text-[#df1b41] px-[12px] py-1 rounded-none'>Delete price</MenuItem>
                                </MenuList>
                            </Menu>
                        </div>
                    </div>
                    <div className='flex my-[16px]'>
                        <div className='pr-4 border-r-[1px] border-[#ebeef1] text-sm'>
                            <h3 className='text-[#687385]'>Product</h3>
                            <button className='text-[#625afa] font-semibold mt-1'>testmain</button>
                        </div>
                        <div className='pl-4 border-l-[1px] border-[#ebeef1] text-sm'>
                            <h3 className='text-[#687385]'>Price per unit</h3>
                            <p className='text-[#414552] mt-1'>${priceData.price_data}.00</p>
                        </div>
                    </div>
                    <div className="mt-12">
                        <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                            <span className="text-[#30313d] text-[20px] font-bold">Metadata</span>
                            <button onClick={handleAddMetadata} disabled={options.metaData ? true : false} className={`${options.metaData && "opacity-60 "} h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2`}><PencilIcon />Edit metadata</button>
                        </div>
                        <div className='mt-3'>
                            {options.metaData ?
                                <div>
                                    <div className="w-full flex gap-3 pb-5 border-b-[1px] border-[#ebeef1]">
                                        <input type="text" placeholder="Key" className="input_focus_shadow max-w-[175px] text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]" />
                                        <textarea placeholder="Value" className="input_focus_shadow py-1 text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]" />
                                        <button>
                                            <AiTwotoneDelete className="text-[18px] text-[#625afa]" />
                                        </button>
                                    </div>
                                    <div className='flex justify-between items-center'>
                                        <button className="sm:ml-3 flex items-center gap-1 text-sm font-semibold text-[#625afa]"><BiPlus className='text-[18px]' /> Add custom field</button>
                                        <div className="font-semibold sm:p-[16px_20px] p-[16px_0] flex text-base text-gray-900 gap-2">
                                            <button onClick={handleAddMetadata} className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px]">Cancel</button>
                                            <button className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Save</button>
                                        </div>
                                    </div>
                                </div> :
                                <p className='text-sm text-[#a3acba]'>No metadata</p>
                            }
                        </div>
                    </div>
                    <div className="mt-12">
                        <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                            <span className="text-[#30313d] text-[20px] font-bold">Pricing</span>
                        </div>
                        <div className="grid sm:grid-cols-2 grid-cols-1 mt-4">
                            <div>
                                <div className='flex text-sm'>
                                    <div className='text-[#687385] max-w-[240px] w-full'>Currency</div>
                                    <span className='text-[#414552] font-normal'>{priceData.select_currency}</span>
                                </div>
                                <div className='flex text-sm mt-2'>
                                    <div className='text-[#687385] max-w-[240px] w-full'>Interval</div>
                                    <span className='text-[#414552] font-normal'>One-time</span>
                                </div>
                                <div className='flex text-sm mt-2'>
                                    <div className='text-[#687385] max-w-[240px] w-full'>Price per unit</div>
                                    <span className='text-[#414552] font-normal'>${priceData.price_data}.00</span>
                                </div>
                                <div className='flex text-sm mt-2'>
                                    <div className='text-[#687385] max-w-[240px] w-full'>Default price</div>
                                    <span className='text-[#414552] font-normal'>No</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-12">
                        <div className="pb-3 border-b-[1px] border-[#ebeef1] flex justify-between items-center">
                            <span className="text-[#30313d] text-[20px] font-bold">Currencies</span>
                        </div>
                        <div className="mt-4">
                            <p className='text-[#687385]'>No other currency options</p>
                        </div>
                    </div>
                    <div className="mt-12">
                        <div>
                            <div className="flex justify-between py-[12px]">
                                <span className="text-[#1a1b25] text-[20px] font-bold">Logs</span>
                            </div>
                            <div className='w-full overflow-x-auto'>
                                <div className='sm:w-full w-[610px] overflow-x-auto'>
                                    <div className="flex justify-between border-t-[1px] border-[#ebeef1] items-center p-[9px_4px] hover:bg-[#f6f8fa] cursor-pointer">
                                        <div className="flex items-center gap-6">
                                            <div className="bg-[#ebeef1] text-[#545969] p-[1px_6px] rounded-[4px] text-xs font-semibold">200 OK</div>
                                            <div>
                                                <code className="text-[13px] text-[#585969]">POST /v1/products/prod_O2NtrSnO6Tpf91</code>
                                            </div>
                                        </div>
                                        <span className="text-[#687385] text-sm">6/12/23, 4:38:50 PM</span>
                                    </div>
                                    <div className="flex justify-between border-t-[1px] border-[#ebeef1] items-center p-[9px_4px] hover:bg-[#f6f8fa] cursor-pointer">
                                        <div className="flex items-center gap-6">
                                            <div className="bg-[#fcedb9] text-[#a82c00] p-[1px_6px] rounded-[4px] text-xs font-semibold">401 ERR</div>
                                            <div>
                                                <code className="text-[13px] text-[#585969]">POST /v1/products/prod_O2NtrSnO6Tpf91</code>
                                            </div>
                                        </div>
                                        <span className="text-[#687385] text-sm">6/12/23, 4:38:50 PM</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-12">
                        <div>
                            <div className="flex justify-between py-[12px]">
                                <span className="text-[#1a1b25] text-[20px] font-bold">Events</span>
                            </div>
                            <div className='w-full overflow-x-auto'>
                                <div className='sm:w-full w-[610px] overflow-x-auto'>
                                    <div className="flex justify-between border-t-[1px] border-[#ebeef1] items-center p-[9px_4px] hover:bg-[#f6f8fa] cursor-pointer">
                                        <div className="flex items-center gap-6">
                                            <div>
                                                <span className="text-[13px] text-[#585969]">A product with ID prod_O2NtrSnO6Tpf91 was updated</span>
                                            </div>
                                        </div>
                                        <span className="text-[#687385] text-sm">6/12/23, 4:38:50 PM</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ArchiveProductModal active={active} setActive={setActive} sendData={sendData} />
            <AddPriceModal addPrice={addPrice} setAddPrice={setAddPrice} editPrice={editPrice} setEditPrice={setEditPrice} />
            <DeleteProductModal
                delProduct={delProduct}
                setDelProduct={setDelProduct}
                sendData={sendData}
                deleteProduct={deleteProduct}
                setDeleteProduct={setDeleteProduct}
                prodDel={prodDel}
                setProdDel={setProdDel} />
        </>
    )
}

export default ProductPriceDetail